import { mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBM_CUSTOM_06_Schema } from './M_TBM_CUSTOM_06_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';

/** tbm 참석자 저장 SP_M10605_U1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBM_CUSTOM_06_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.TBM.saveTbmBasicU6, payload);
  }, options);
};
